import axios from 'axios';
import Forms from '../forms/form';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import { loadRecaptcha } from '../app';

export default class FormContato {
    constructor() {
        this.form = document.querySelector('#formContact');
        this.formFields = this.form.querySelectorAll('input, select, textarea')
		this.successMessage = document.querySelector('.modulo-formulario .success-form')
		this.errorMessage = document.querySelector('.modulo-formulario .error-form')
        this.btnSubmit = this.form.querySelector('button');

        this.ready();
        this.initRecaptcha();

        new Forms();

        console.log(appConfig.urlsite)

    }

    ready() {

        new Bouncer(`#formContact`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });

        document.addEventListener('bouncerShowError', (event) => {
            this.formFields.forEach(field => {
                if(field.classList.contains('error-field')) {
                    this.errorMessage.classList.remove('hidden')
                    // this.errorMessage.scrollIntoView({ behavior: 'smooth' });
                }
            })

        }, false);

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendFormContactAjax(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach(field => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    // window.reloadCaptcha();
                    loadRecaptcha()
                }
            })
        })
    }

    sendFormContactAjax(form) {
        this.btnSubmit.disabled = true;
        this.btnSubmit.classList.add('loading')
        
        reloadCaptcha('contact', 'g-recaptcha-response', () => {
			this.btnSubmit.disabled = true
			const dataForm = new FormData(form)
            
			if (this.form.querySelector('#privacy').checked) {
                dataForm.set('privacy', 1);
			} else {
                dataForm.set('privacy', 0);
			}
	
			axios({
                method: 'POST',
                url: appConfig.urlsite + '/email/form_contato.php',
                data: dataForm,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((response) => {
                
                if (response.data.status === 'success') {
                    form.reset();
                    this.successMessage.classList.remove('hidden');
                    this.errorMessage.classList.add('hidden');
                    this.errorMessage.classList.add('hidden');
                } else {
                    this.successMessage.classList.add('hidden');
                    this.errorMessage.classList.remove('hidden');
                }
            })
            .catch((error) => {
                console.error('Erro ao enviar:', error);
                
                // Se a resposta tem JSON:
                const mensagem = error.response?.data?.message || 'Erro desconhecido ao enviar o formulário.';
                
                this.successMessage.classList.add('hidden');
                this.errorMessage.classList.remove('hidden');
                this.errorMessage.innerText = mensagem;
            })
            .finally(() => {
                this.btnSubmit.disabled = false;
                this.btnSubmit.classList.remove('loading');
            });

		})
    }
    
}
if(document.querySelector('.modulo-formulario')) {
    new FormContato()
}